import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Home/Logo.png';

const FooterWrapper = styled.footer`
  background-color: #2b3545;
  padding: 100px 0 30px;
  color: white;
`;

const FooterTitle = styled.h3`
  font-size: var(--fs-ss-28, 28px);
  font-weight: 500;
  margin-bottom: 30px;
  line-height: 1.2;
  
  span {
    color: #e4880f;
  }
`;

const FooterDescription = styled.p`
  font-size: 15px;
  line-height: 1.6;
  margin-top: 20px;
  margin-bottom: 30px;
  color: #ebebeb;
  font-family: 'Montserrat', sans-serif;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  
  a {
    color: white;
    transition: all 0.3s ease;
    font-size: 20px;
    
    &:hover {
      color: #e4880f;
    }
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  
  .icon {
    color: #e4880f;
    font-size: 20px;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .content {
    color: #ebebeb;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
    
    a {
      color: #ebebeb;
      text-decoration: none;
      
      &:hover {
        color: #e4880f;
      }
    }
  }
`;

const SubscribeForm = styled.div`
  position: relative;
  margin-top: 20px;
  
  input {
    width: 100%;
    padding: 12px 50px 12px 15px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.05);
    color: white;
    font-size: 14px;
    outline: none;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }
  
  button {
    position: absolute;
    right: 5px;
    top: 5px;
    bottom: 5px;
    background-color: #e4880f;
    border: none;
    color: white;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    &:hover {
      background-color: #d17800;
    }
    
    i {
      font-size: 24px;
    }
  }
`;

const FooterMessage = styled.p`
  font-size: 15px;
  color: #ebebeb;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 20px;
`;

const Divider = styled.hr`
  border-color: rgba(255, 255, 255, 0.1);
  margin: 40px 0 20px;
`;

const Copyright = styled.div`
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Montserrat', sans-serif;
`;

const FooterContainer = styled(Container)`
  padding-left: 25px;
  padding-right: 25px;
  
  @media (min-width: 992px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <Row className="mb-5 gx-5">
          <Col lg={4} md={6} className="mb-4 mb-lg-0 pe-lg-5">
            <div className="mb-4">
              <img src={logo} alt="FabXpert Logo" width="100" height="auto" />
            </div>
            <FooterDescription>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo
              viverra maecenas accumsan lacus vel facilisis.
            </FooterDescription>
            <SocialIcons>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-youtube"></i>
              </a>
            </SocialIcons>
          </Col>
          
          <Col lg={4} md={6} className="mb-4 mb-lg-0 px-lg-5">
            <FooterTitle>
              Contact <span>Us</span>
            </FooterTitle>
            <ContactItem>
              <div className="icon">
                <i className="bi bi-geo-alt-fill"></i>
              </div>
              <div className="content">
                2231 Johnstown Road Bensenville, IL 60106
              </div>
            </ContactItem>
            <ContactItem>
              <div className="icon">
                <i className="bi bi-telephone-fill"></i>
              </div>
              <div className="content">
                <a href="tel:+12340567890">+1 234 056 78 90</a>
              </div>
            </ContactItem>
            <ContactItem>
              <div className="icon">
                <i className="bi bi-envelope-fill"></i>
              </div>
              <div className="content">
                <a href="mailto:info@fabxpert.com">info@fabxpert.com</a>
              </div>
            </ContactItem>
          </Col>
          
          <Col lg={4} md={6} className="ps-lg-5">
            <FooterTitle>
              Subscribe <span>Us</span>
            </FooterTitle>
            <FooterMessage>
              Stay updated with our latest news. We promise not to spam!
            </FooterMessage>
            <SubscribeForm>
              <input type="email" placeholder="Your Email" />
              <button type="button" aria-label="Subscribe">
                <i className="bi bi-arrow-right"></i>
              </button>
            </SubscribeForm>
          </Col>
        </Row>
        <Divider />
        <Copyright>
          &copy; {new Date().getFullYear()} FabXpert. All Rights Reserved.
        </Copyright>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer; 